import accountReviewStorage from "app/pages/sales-intelligence/sub-modules/account-overview/shared/services/storage/storage";
import { isHidden } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

export function getOverviewGroupInitiallyOpened() {
    const isOverviewGroupOpenedFromLS = accountReviewStorage.isWebsiteGroupOpened("accountreview_overview");

    return !!(isOverviewGroupOpenedFromLS ?? isHidden(swSettings.components.WsWebSearchOverview));
}
